import { NorthCapitalAccountId } from '../models/account-id';
import { IsNotEmpty, IsString } from 'class-validator';

export class GetAiLetterRequest {
    @IsString()
    @IsNotEmpty()
    accountId: NorthCapitalAccountId;
}
